export default function Footer() {
  return (
    <footer className="w-full py-12 px-4 border-t border-nerd-purple/10" style={{ background: '#0a0a1a' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="font-display text-xl font-bold text-gradient mb-2">NERD COACH</div>
            <p className="text-nerd-gray text-xs leading-relaxed">
              Coaching mentale e fisico per chi vive tra schermi e mondi immaginari.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display text-xs uppercase tracking-wider text-nerd-white mb-4">Navigazione</h4>
            <ul className="space-y-2">
              {[
                { label: 'Metodo', href: '#metodo' },
                { label: 'Percorsi', href: '#percorso' },
                { label: 'Analisi', href: '#analisi' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xs uppercase tracking-wider text-nerd-white mb-4">Legale</h4>
            <ul className="space-y-2">
              {['Privacy', 'Termini'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xs uppercase tracking-wider text-nerd-white mb-4">Social</h4>
            <ul className="space-y-2">
              {[
                { label: 'Instagram', href: '#' },
                { label: 'TikTok', href: '#' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-nerd-purple/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="text-nerd-gray/50 text-xs">
            © {new Date().getFullYear()} Nerd Coach. Tutti i diritti riservati.
          </span>
          <span className="text-nerd-gray/50 text-xs font-display">
            nerdcoach.it
          </span>
        </div>
      </div>
    </footer>
  )
}
